import React from 'react';
import { Box } from 'grommet/es6/components/Box';

import { Spinning } from '../../Spinning';

export default (function (_ref) {
  var loading = _ref.loading;
  return React.createElement(
    'div',
    null,
    loading && React.createElement(
      Box,
      { align: 'center', full: 'horizontal', pad: { vertical: 'large' } },
      React.createElement(Spinning, null)
    )
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/components/PagingTable/components/LoadingComponent.js
// module id = 1186
// module chunks = 0